import { useState, useCallback } from 'react';
import { copyToClipboard } from './Toast';

interface CodeRevealProps {
  code: string;
  onCopied?: () => void;
}

function maskCode() {
  return '\u2022\u2022\u2022\u2022-\u2022\u2022\u2022\u2022-\u2022\u2022\u2022\u2022';
}

export const CodeReveal = ({ code, onCopied }: CodeRevealProps) => {
  const [revealed, setRevealed] = useState(false);
  const displayCode = revealed ? code : maskCode();

  const handleCopy = useCallback(async () => {
    const ok = await copyToClipboard(code);
    if (ok) onCopied?.();
  }, [code, onCopied]);

  return (
    <div
      style={{
        width: '100%',
        padding: 12,
        borderRadius: 8,
        border: '1.5px solid #FBBF24',
        background: 'rgba(255,255,255,0.05)',
      }}
    >
      {/* Header row */}
      <div className='mb-2 flex items-center justify-between'>
        <span className='text-[10px] text-[#FFFFFF]/70'>REDEEM CODE</span>
        <button
          type='button'
          onClick={() => setRevealed((v) => !v)}
          className='border-none bg-transparent p-0 text-[11px] font-semibold text-[#FFFFFF]/80 transition-opacity hover:opacity-80'
        >
          {revealed ? 'Hide' : 'Reveal'}
        </button>
      </div>
      {/* Code + copy button row */}
      <div className='flex items-center gap-2'>
        <span
          className='min-w-0 flex-1 font-mono font-semibold text-white'
          style={{ fontSize: revealed ? 13 : 12, letterSpacing: revealed ? 0.8 : 1, overflowWrap: 'anywhere', lineHeight: 1.4 }}
        >
          {displayCode}
        </span>
        <button
          type='button'
          aria-label='Copy code'
          onClick={handleCopy}
          className='inline-flex shrink-0 items-center justify-center transition-opacity hover:opacity-80'
          style={{
            border: '1px solid rgba(255,255,255,0.15)',
            background: 'rgba(255,255,255,0.08)',
            borderRadius: 6,
            padding: 6,
          }}
        >
          <svg width='14' height='14' viewBox='0 0 16 16' aria-hidden='true' style={{ flexShrink: 0 }}>
            <rect x='5.5' y='5.5' width='8' height='8' rx='1.5' fill='none' stroke='rgba(255,255,255,0.6)' strokeWidth='1.3' />
            <path d='M3.5 10.5 V3.5 A1 1 0 0 1 4.5 2.5 H10.5' fill='none' stroke='rgba(255,255,255,0.6)' strokeWidth='1.3' strokeLinecap='round' />
          </svg>
        </button>
      </div>
    </div>
  );
};
